<template>
   <div class="status-modal">
      <div class="status-modal-container">
         <div class="status-modal-container-img">
            <div :class="status ? 'success' : 'fail'">
               <div class="img-container">
                  <img :src="status ? `${publicPath}imgs/success_face.png` :`${publicPath}imgs/error_face.png`" alt="" />
               </div>
            </div>
         </div>
         <div class="status-modal-container-message" v-html=msg></div>
         <div class="status-modal-container-accept">
            <button @click="close">Aceptar</button>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   props: {
      msg: { require: true },
      status: { require: true },
   },
   data() {
      return {
         publicPath: process.env.BASE_URL,
      };
   },
   mounted() {
      window.addEventListener("keydown", this.handleKeyDown);
   },
   methods: {
      close() {
         this.$emit("close");
      },
      handleKeyDown(event) {
         if (event.key === "Escape") {
            this.close();
         }
      },
   },
   beforeDestroy() {
      window.removeEventListener("keydown", this.handleKeyDown);
   },
};
</script>